// extracted by mini-css-extract-plugin
module.exports = {"box_07":"box_07-17N-LGJc","clearfix":"clearfix-_D429AGy","box_07_a":"box_07_a-3PIbvd7q","bag":"bag-1DBcGrBe","text_02":"text_02-1_P9AWbQ"};